export default function StarRating({ rating = 0, count = 0, size = 'sm', onRate }) {
  const stars = [1, 2, 3, 4, 5];
  return (
    <div className="flex items-center gap-1">
      {stars.map(s => (
        <button key={s} type="button" onClick={() => onRate?.(s)}
          className={`${size === 'sm' ? 'text-sm' : 'text-lg'} ${s <= Math.round(rating) ? 'text-yellow-400' : 'text-gray-300'} ${onRate ? 'cursor-pointer hover:text-yellow-500' : 'cursor-default'}`}
        >★</button>
      ))}
      {count > 0 && <span className="text-xs text-gray-500 ml-1">({count})</span>}
    </div>
  );
}
